<template>
  <div class="home">
    欢迎进入后台管理系统
  </div>
</template>

<script>


export default {
  name: 'Home'
}
</script>

<style scoped lang="less">
.home {
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
